import ByteBuffer from 'bytebuffer'
import { forEach, keys } from 'lodash-es'

const extend = {
  static: {
    eWriteStart: (() => {
      let bb = null
      return (cmd) => {
        if (!bb) {
          bb = new ByteBuffer(1024 * 10, ByteBuffer.LITTLE_ENDIAN)
        }
        bb.offset = 0
        // 标识
        bb.eWriteString('QS')
        // 消息长度占位
        bb.writeUint16(0)
        // 消息类型
        bb.writeUint16(cmd)
        return bb
      }
    })()
  },
  instance: {
    eWriteEnd() {
      const offset = this.offset
      // 从 2 位置覆写消息长度
      this.writeInt16(offset - 6, 2)
      this.offset = offset
      return this
    },
    // 扩展自定义写入字符串
    eWriteString(str) {
      forEach(str, v => {
        const code = v.charCodeAt(0)
        if (code > 0x0 && code <= 0x7f) {
          // 单字节 UTF-16 0000 - 007F UTF-8  0xxxxxxx
          this.writeInt8(code)
        } else if (code >= 0x80 && code <= 0x7ff) {
          // 双字节 UTF-16 0080 - 07FF UTF-8  110xxxxx 10xxxxxx 110xxxxx
          this.writeInt8((0xc0 | ((code >> 6) & 0x1f)))
          // 10xxxxxx
          this.writeInt8((0x80 | (code & 0x3f)))
        } else if (code >= 0x800 && code <= 0xffff) {
          // 三字节 UTF-16 0800 - FFFF UTF-8  1110xxxx 10xxxxxx 10xxxxxx
          this.writeInt8((0xe0 | ((code >> 12) & 0xf)))
          this.writeInt8((0x80 | ((code >> 6) & 0x3f)))
          this.writeInt8((0x80 | (code & 0x3f)))
        }
      })
      return this
    },
    // 扩展自定义写入 UTF8 字符串
    eWriteUTF8String(str) {
      // 开始位置
      const offset1 = this.offset
      // 字符串长度占位
      this.writeInt32(0)
      // 字符串内容
      this.eWriteString(str)
      // 文本结束符
      this.writeUint8(0)
      // 结束位置
      const offset2 = this.offset
      // 覆写字符串长度
      this.writeInt32(offset2 - offset1 - 4, offset1)
      this.offset = offset2
      return this
    },
    // 扩展自定义读取 UTF8 字符串
    eReadUTF8String() {
      const len = this.readInt32()
      if (this.buffer.byteLength < this.offset + len) {
        console.log('read end-of-file readStringUTF8, cmd:', this.eGetCmd())
        return ''
      }
      const codes = [...keys(Array(len))].map(() => this.readUint8())
      let str = ''
      // 最后一个占位符 0 不需要
      while (codes.length - 1 > 0) {
        const code = codes.shift()
        if (((code >> 7) & 0xff) === 0x0) {
          str += String.fromCharCode(code)
        } else if (((code >> 5) & 0xff) === 0x6) {
          // 双字节  110xxxxx 10xxxxxx
          const b1 = code & 0x1f
          const b2 = codes.shift() & 0x3f
          str += String.fromCharCode(((b1 << 6) | b2))
        } else if (((code >> 4) & 0xff) === 0xe) {
          // 三字节  1110xxxx 10xxxxxx 10xxxxxx
          const code2 = codes.shift()
          const code3 = codes.shift()
          const b1 = (code << 4) | ((code2 >> 2) & 0xf)
          const b2 = ((code2 & 0x3) << 6) | (code3 & 0x3f)
          str += String.fromCharCode((b1 << 8) | b2)
        }
      }
      return str
    },
    eGetCmd() {
      return this.slice(4, 6).readUint16()
    }
  }
}

Object.assign(ByteBuffer, extend.static)
Object.assign(ByteBuffer.prototype, extend.instance)

export default ByteBuffer
